import { allCountries } from 'country-region-data';

function countryRecord(countryName) {
  const name = String(countryName || '').trim().toLowerCase();
  if (!name) return null;
  return allCountries.find((country) => String(country[0]).toLowerCase() === name) || null;
}

export function provinceOptions(countryName) {
  const country = countryRecord(countryName);
  if (!country) return [];
  return country[2].map((region) => region[0]).filter(Boolean);
}

/** Case/whitespace-insensitive membership check, so "south africa" is treated as the same option as "South Africa". */
function optionsInclude(options, value) {
  const target = String(value || '').trim().toLowerCase();
  if (!target) return false;
  return options.some((option) => String(option || '').trim().toLowerCase() === target);
}

/**
 * Given free-typed text and a canonical list of options, returns the canonically-cased
 * option when there's a case-insensitive match (e.g. "south africa" -> "South Africa"),
 * otherwise returns the trimmed text unchanged.
 */
export function normalizeToOption(value, options = []) {
  const trimmed = String(value || '').trim();
  if (!trimmed) return trimmed;
  const target = trimmed.toLowerCase();
  const match = options.find((option) => String(option || '').trim().toLowerCase() === target);
  return match !== undefined ? match : trimmed;
}

export function withCurrentOption(options, current) {
  const value = String(current || '').trim();
  if (!value || optionsInclude(options, value)) return options;
  return [value, ...options];
}

export function withCurrentOptions(options, currentValues = []) {
  const missing = currentValues
    .map(value => String(value || '').trim())
    .filter(value => value && !optionsInclude(options, value));
  return missing.length ? [...missing, ...options] : options;
}

/** A customer's provinces: the `provinces` list when the API sends it, else the single `province`. */
export function customerProvinces(customer) {
  if (Array.isArray(customer?.provinces)) {
    return customer.provinces.map(value => String(value || '').trim()).filter(Boolean);
  }
  const single = String(customer?.province || '').trim();
  return single ? [single] : [];
}

export function formatProvinces(customer, empty = '') {
  const list = customerProvinces(customer);
  return list.length ? list.join(', ') : empty;
}
